import type { Language } from '@server/graphql/typeDefs/types'

export function languageToAcceptLanguage(language: Language | string): string {
  return language.replace('_', '-')
}

export function acceptLanguageToLanguage(acceptLanguage: string): Language {
  return acceptLanguage.replace('-', '_') as Language
}
